/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 1ae6e2d8 (Tue May  5 20:16:57 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
/**
 *
 * @export
 * @interface SearchPossibleEventOwnersResponsePossibleOwners
 */
export interface SearchPossibleEventOwnersResponsePossibleOwners {
  /**
   * The unique identifier of the actor record for the possible event owner.
   * @type number
   * @memberof SearchPossibleEventOwnersResponsePossibleOwners
   */
  actorKey: number
  /**
   * The full name of the potential event owner.
   * @type string
   * @memberof SearchPossibleEventOwnersResponsePossibleOwners
   */
  fullName: string
  /**
   * The full name of the potential event owner's supervisor in the team tree.
   * @type string
   * @memberof SearchPossibleEventOwnersResponsePossibleOwners
   */
  supervisorsFullName?: string
  /**
   * The name of the role for the potential owner. Used to differentiate between multiple actors so the right record is picked.
   * @type string
   * @memberof SearchPossibleEventOwnersResponsePossibleOwners
   */
  roleName: string
}

export function SearchPossibleEventOwnersResponsePossibleOwnersFromJSON(
  json: any
): SearchPossibleEventOwnersResponsePossibleOwners {
  return SearchPossibleEventOwnersResponsePossibleOwnersFromJSONTyped(
    json,
    false
  )
}

export function SearchPossibleEventOwnersResponsePossibleOwnersFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): SearchPossibleEventOwnersResponsePossibleOwners {
  if (json === undefined || json === null) {
    return json
  }
  return {
    actorKey: json['actorKey'],
    fullName: json['fullName'],
    supervisorsFullName: !exists(json, 'supervisorsFullName')
      ? undefined
      : json['supervisorsFullName'],
    roleName: json['roleName'],
  }
}

export function SearchPossibleEventOwnersResponsePossibleOwnersToJSON(
  value?: SearchPossibleEventOwnersResponsePossibleOwners | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    actorKey: value.actorKey,
    fullName: value.fullName,
    supervisorsFullName: value.supervisorsFullName,
    roleName: value.roleName,
  }
}
